import { AddIcon, LeftArrowIcon, RemoveIcon, RightArrowIcon } from "src/assets";
import { ButtonProps } from "src/types";

export const flavors: Record<string, ButtonProps> = {
  // Primary
  primary: {
    classes: "primary",
  },
  primaryBack: {
    classes: "primary",
    classesIconLeft: "filter-white",
    iconLeft: LeftArrowIcon,
  },
  primaryNext: {
    classes: "primary",
    classesIconRight: "filter-white",
    iconRight: RightArrowIcon,
  },
  primaryFlip: {
    classes: "primary-flip",
  },
  primaryAdd: {
    classes: "primary",
    iconLeft: AddIcon,
    classesIconLeft: "filter-primary",
  },
  primaryRemove: {
    classes: "primary",
    iconLeft: RemoveIcon,
    classesIconLeft: "filter-primary",
  },
  primaryFlipAdd: {
    classes: "primary-flip",
    iconLeft: AddIcon,
    classesIconLeft: "filter-primary",
  },
  primaryFlipRemove: {
    classes: "primary-flip",
    iconLeft: RemoveIcon,
    classesIconLeft: "filter-primary",
  },
  // Transparent accent
  transparentAccent: {
    classes: "transparent-accent",
  },
  transparentAccentBack: {
    classes: "transparent-accent",
    classesIconLeft: "filter-primary",
    iconLeft: LeftArrowIcon,
  },
  transparentAccentNext: {
    classes: "transparent-accent",
    classesIconRight: "filter-primary",
    iconRight: RightArrowIcon,
  },
  //Accent
  accent: {
    classes: "accent",
  },
};
